import { vuexPto } from '@/store/compositionV2/module/pto'
import {
  PTOHandbookMeasureUnitApi,
  PTOHandbookNomenclatureStandardApi,
  PTOHandbookNomenclatureTypeApi,
  PTONomenclatureApi
} from '@/api/pto'
import { priceFormat } from '@/utils/form/priceFormat'
import { vuexCreateFromSelectSearch } from '@/store/compositionV2/utils/create-from-select-search'
import { getHandbookName } from '@/utils/string'

const state = () => ({
  ...vuexPto.createState(),
  api: PTONomenclatureApi,
  namePageDetailed: 'PtoProjectPtoNomenclatureUpdate',
  expand: 'supply,type,measure_unit,standard',

  handbookApiList: [
    {
      api: PTOHandbookNomenclatureTypeApi,
      key: 'type'
    },
    {
      api: PTOHandbookNomenclatureStandardApi,
      key: 'standard'
    },
    {
      api: PTOHandbookMeasureUnitApi,
      key: 'measure_unit'
    }
  ],

  tableHeaders: [
    {
      title: 'Наименование',
      isSortable: true,
      sortName: 'type.name'
    },
    {
      title: 'Стандарт',
      isSortable: true,
      sortName: 'standard.name'
    },
    {
      title: 'Ед. изм.',
      isSortable: true,
      sortName: 'measure_unit.name'
    },
    {
      title: 'Кол-во',
      isSortable: true,
      sortName: 'quantity'
    },
    {
      title: 'Характеристики',
      isSortable: false,
      sortName: ''
    }
  ]
})

const getters = {
  ...vuexPto.createGetters(),
  getList: state => {
    return state.list.map(item => {
      return {
        isControlsActive: item.isControlsActive,
        isActive: item.isActive,
        id: item.id,
        values: [
          getHandbookName(item.type),
          getHandbookName(item.standard),
          getHandbookName(item.measure_unit),
          priceFormat(item.quantity) || '-',
          { data: item.note || '-', mod: 'comments' }
        ]
      }
    })
  }
}

const mutations = {
  ...vuexPto.createMutations()
}

const actions = {
  ...vuexPto.createActions(),
  ...vuexCreateFromSelectSearch.createActions(),

  async createItem ({ state, dispatch }, data) {
    await dispatch('createHandbookItemsAndSetDataId', { data })
    return state.api.create(data)
  },

  async updateItem ({ state, dispatch, getters }, data) {
    await dispatch('createHandbookItemsAndSetDataId', { data })
    return state.api.update(getters.getCurrentItemId, data)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
